"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StyledLink = _interopRequireDefault(require("../StyledLink"));

var _material = require("@mui/material");

require("./Breadcrumbs.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
*
* Breadcrumbs
*
*/
function Breadcrumbs(_ref) {
  var crumbs = _ref.crumbs;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Breadcrumbs_container hideOnPrint"
  }, crumbs.map(function (crumb, index) {
    if (index === crumbs.length - 1) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: "text-".concat(crumb.title)
      }, crumb.title);
    } else {
      if (crumb.link) {
        return [/*#__PURE__*/_react["default"].createElement(_StyledLink["default"], {
          to: crumb.link,
          key: "link-".concat(crumb.title)
        }, crumb.title), /*#__PURE__*/_react["default"].createElement(_material.Icon, {
          key: "icon-".concat(crumb.title)
        }, "keyboard_arrow_right")];
      } else {
        return [/*#__PURE__*/_react["default"].createElement("span", {
          key: "text-".concat(crumb.title)
        }, crumb.title), /*#__PURE__*/_react["default"].createElement(_material.Icon, {
          key: "icon-".concat(crumb.title)
        }, "keyboard_arrow_right")];
      }
    }
  }));
}

Breadcrumbs.propTypes = {
  crumbs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string.isRequired,
    link: _propTypes["default"].string
  })).isRequired
};
var _default = Breadcrumbs;
exports["default"] = _default;